import { Column, DeleteRow, Row } from '~components/table-view-v3';

const columnsFactory = (onDelete: (row: Row) => void): Column[] => [
  {
    id: 'name',
    header: 'Service Name',
    type: 'text',
  },
  {
    id: 'delete-button',
    header: '',
    type: 'custom',
    style: { width: '50px' },
    component: DeleteRow,
    componentProps: {
      onDelete,
      tooltip: 'Remove exclusion',
    },
  },
];

export default columnsFactory;
